/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable*/
import { Button, Tooltip } from '@mui/material';
import { connect } from 'react-redux';
import Chip from '@mui/material/Chip';
import {
	useCallback, useEffect, useMemo, useRef, useState
} from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import moment from 'moment';
import { useHistory } from 'react-router';
import {
	analyticsAction, formActions, modalActions
} from '../../../Actions';
import { ListTable } from '../../../Components/ListTable';
import { POItemsModal } from '../../../Components/Modals/POItemsModal';
import styles from './CapexOrderListPage.module.scss';
import { VanImageModal } from '../../../Components/Modals/VanImageModal';
import assetServices from '../../../Services/AssetServices/asset.services';
import { notificationServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import { AlertModal } from '../../../Components/Modals';
import { VendorOrderGrnsModal } from '../../../Components/Modals/VendorOrderGrns';
import { orderTypes, urls } from '../../../Constants';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import { classes, filtersInfoChip, handleResponseStreamDownload } from '../../../Helpers';
import orderAnalyticsServices from '@/Services/Analytics Services/orderAnalytics.services';
import { ItemsModal } from '../../../Components/Modals/ItemsModal';
import { useAuth } from '@/Components/Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { CheckCircleIcon, Filter, RefreshCcw } from 'lucide-react';
import GlobalSearch from '@/Components/globalSearch/search';
import drawerActions from '@/Actions/drawer.actions';
import CustomModal from '@/Components/Modals/CustomModal/CustomModal';
import { getStorageKey } from '../CreatePurchaseOrder/CreatePurchaseOrder.config';
import { loadState } from '@/Helpers/persistenceUtils';

const TABLE_COLUMNS = [
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatch By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor Challan ID',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Order Date',
		config: {
			type: 'DATA',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'Download',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'View More',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Actions',
		config: {
			type: 'CANCEL',
		},
	},
	// {
	// 	title: 'MORE',
	// 	config: {
	// 		type: 'MORE',
	// 	},
	// },
];

const COLMAP = {
	'PO Id': 'id',
	'Client PO Id': 'clientPoId',
	'Order Date': 'createdAt',
	'Dispatch By': 'scheduledAt',
	'Delivery Time': 'deliveryTime',
	'Deliver To': 'storeName',
	BASE: 'fromStoreName',
	'Van Temp': 'receivingTemp',
	'Transit Van Image': 'receivingTempImage',
	'Order Status': 'id',
	'Vendor Challan ID': 'vendorChallanId',
	Vendor: 'vendorName',
};

const filterOrderStatus = [
	'CANCELLED',
	'PENDING',
	'FULFILLED',
	'APPROVAL_PENDING',
	'APPROVAL_REJECTED',
];

const dateTypeArr = [
	{
		label: 'Order Date',
		value: 'ordered',
	},
	{
		label: 'Dispatch By',
		value: 'scheduled',
	},
];

const capexOrderExportTypes = [
	{
		label: 'Item-Wise PO Fulfillment',
		value: 'capexPoItemWise',
	},
	{
		label: 'Item-Wise GRN Register',
		value: 'capexGrnItemsWise',
	},
];

const SwitchTab = ({ options = ['capex', 'service'], onTabChange, activeTabName = 'capex' }) => {
	const [activeTab, setActiveTab] = useState(activeTabName);

	useEffect(() => {
		setActiveTab(activeTabName);
	}, [activeTabName]);

	const handleTabClick = (tab) => {
		setActiveTab(tab);
		if (onTabChange) {
			onTabChange(tab);
		}
	};

	return (
		<div className="flex justify-start p-1 bg-yellow-100 rounded-lg w-fit">
			{options.map((option) => (
				<button
					key={option}
					className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${activeTab === option
						? 'bg-[#ffb703] shadow text-white'
						: 'text-yellow-800 hover:text-yellow-900'
						}`}
					onClick={() => handleTabClick(option)}
				>
					{option}
				</button>
			))}
		</div>

	);
};

function CapexOrdersListPage(props) {
	const {
		data,
		toggleModal,
		// toggleFileUploaderModal,
		toggleAlert,
		fetchOrdersList,
		toggleVendorOrderGrnsModal,
		dateRangeFilter,
		navState,
		userPermissions,
		toggleVanImageModal,
		vendors,
		fetchVendors,
		resetInventoryAnalyticsState,
		userList,
		fetchUserList,
		toggleFiltersDrawer,
		toggleCustomModal
	} = props;
	const history = useHistory();
	const [update, setUpdate] = useState(-1);
	const searchQuery = '';
	const searchBy = 'clientPoId';
	const [filterValue, setFilterValue] = useState({});
	const navRequisites = navState?.[urls.PURCHASE_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const [search, setSearch] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	const location = useLocation();
	const [orderType, setOrderType] = useState('capex');
	const firstRender = useRef(false);
	const exportFilters = useRef({});
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values(userRolesDict)?.includes('INTERNAL') || Object?.values(userRolesDict)?.includes('CXO Office');
	const levels = [3, 4];

	const isService = useMemo(() => {
		return orderType === 'service'
	}, [orderType])

	// const { userConfig } = useAuth();
	// // function page role of user access
	// const map = new Map(userList.map((item) => [item.value, item.label]));
	// const role = Object.keys(userConfig?.userRoles);
	// const userRoles = [];
	// role.forEach((ele) => {
	// 	userRoles.push(ele);
	// });
	// const pageRole = navState['/analytics/po']?.submenu['/analytics/list/capex/vendor/orders']?.rolesMapped;
	// const findMatchingRole = userRoles.filter((ele) => pageRole.includes(Number(ele)));
	// const roleDetails = findMatchingRole.map((role) => {
	// 	const key = Number(role);
	// 	const name = map.get(key);
	// 	return {
	// 		role: key, name,
	// 	};
	// });
	// const name = roleDetails.some((item) => item.name === 'CXO Office');
	// const isInternal = roleDetails.some((item) => item.name === 'Internal' || item.name === 'CXO Office' || item?.name === 'Procurement');
	// const vendorApproval = roleDetails.some((ele) => ele?.name === 'Procurement');
	// const access = findMatchingRole.length > 0 ? userConfig?.userDetails?.level : false;
	// let permit;
	// if (access === false) {
	// 	permit = false;
	// } else {
	// 	permit = isInternal && access !== 1 ;
	// }

	// end user Acces

	useEffect(() => {
		fetchUserList();
		fetchVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		return () => {
			resetInventoryAnalyticsState({
				entity: 'INVENTORY_ANALYTICS',
				method: 'VENDOR_ORDERS_LIST',
				data: [],
			});
		};
	}, []);

	const handleCancelPo = (id, clientPoId) => {
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Cancelling Order ${clientPoId || id || ''}`.trim(),
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status: 'CANCEL',
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => {
					return prev + 1;
				});
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleFulfillPo = (id, orderType = 'capex') => {
		(async () => {
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status: 'GRN_FULFILL',
						},
					}
				);
				if (resp?.statusCode === 200) {
					notificationServices.generateNotification({
						type: 'success',
						message: 'PO Successfully fulfilled',
					});
					setUpdate((prev) => {
						return prev + 1;
					});
					setFilterValue(p => ({ ...p, orderType: orderType }))
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log('some error', error);
			} finally {
				toggleCustomModal(false);
			}
		})();
	};

	const handleViewClick = (item) => {
		const vendorDetails = vendors?.find((ele) => {
			return ele?.id === item?.vendorId;
		});
		toggleModal(true, {
			heading: `${isService ? 'Service Orders' : `Items of Asset Purchase Orders`} ${item?.clientPoId ? `of ${item?.clientPoId}` : ''
				}`,
			...item,
			showPdf: item?.poURL,
			showTotal: true,
			showPoDetails: true,
			width: '80%',
			height: '70%',
			transactionData: {
				[isService ? 'Service Order ID' : 'Order ID']: item?.clientPoId,
				[isService ? 'Service To Store' : 'Deliver To Store']: item?.storeName,
				Vendor: item?.vendorName,
				'Deliver To Store GSTIN': item?.storeGstin ?? '',
				'Vendor GSTIN': vendorDetails?.gstin ?? '',
				'Payment Term': item?.jsonData?.paymentTerm,
				'Vendor Address': `${vendorDetails?.shippingAddressCity ?? ''
					} ${vendorDetails?.shippingAddressState ?? ''}, ${vendorDetails?.shippingAddressPinCode ?? ''
					}`,
				'Order Date': moment(item?.createdAt).format('YYYY-MM-DD'),
				[isService ? 'Service By Date' : 'Dispatch By']: moment(item?.scheduledAt).format('YYYY-MM-DD'),
			},
			excludedColumns: [
				'Packaged',
				'Dispatched',
				'Received',
				'From Process',
				'PO Id',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
				'Standard PO Qty',
				...(isService ? ['Returned', 'Last Purchase Rate 1', 'Last Purchase Rate 2', 'Last Purchase Rate 3', 'Standard PO Qty'] : []),
			],
		});
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [
			'PO ID',
			'Client PO ID',
			'PO Scheduled Date',
			'PO Order Date',
			'PO Order status',
			'PO Raised by',
			'Vendor',
		];
		const downloadBtn = document.createElement('a');
		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);

	const fetchPOGrns = async (orderId) => {
		const req = {
			data: {
				filters: {
					orderId,
				},
				type: 'GRN',
				children: true,
			},
		};
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'loading...',
		});
		try {
			const response =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req,
				});
			// eslint-disable-next-line no-empty
			if (response?.statusCode === 200) {
				toggleVendorOrderGrnsModal(true, {
					heading: `GRNs of PO: #${orderId}`,
					grnList: response?.data,
					orderType: orderType === 'service' ? 'SERVICE' : 'CAPEX',
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					},
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message,
				config: {
					id: notificationId,
				},
			});
		}
	};

	const showPOBills = (orderId, clientPoId) => {
		history.push(
			`${urls.EXTENSION}${urls.BILLS}?poId=${orderId}&clientPoId=${clientPoId}`
		);
	};

	const viewMoreOptionsList = {
		'View Items': (item, cb) => {
			handleViewClick(item);
			cb();
		},
		'View GRNs': (item, cb) => {
			fetchPOGrns(item?.id);
			cb();
		},
	};

	const SPECIAL_ITEMS = {
		'Client PO Id': (clientPoId, item) => {
			if (!clientPoId) {
				return '-';
			}
			return (
				<div
					role='button'
					tabIndex={0}
					style={{
						cursor: 'pointer',
						color: '#2563eb',
						textDecoration: 'underline',
						textAlign: 'left',
					}}
					onClick={() => handleViewClick(item)}
				>
					{clientPoId}
				</div>
			);
		},
		'Order Status': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			if (item?.orderStatus === 'APPROVAL_REJECTED') {
				return (
					<div className={styles.rejected}>
						<p>
							{item?.orderStatus?.split('_')?.join(' ')}
							{item?.jsonData?.rejectionReason
								? ` (Reason: ${item?.jsonData?.rejectionReason})`
								: ''}
						</p>
					</div>
				);
			}
			return item?.orderStatus?.split('_')?.join(' ');
		},
		'Van Temp': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return item?.receivingTemp ?? '-';
		},
		'Transit Van Image': (id, src) => {
			const item = data?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{item?.receivingTempImage ? (
						// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
						<img
							onClick={() => {
								toggleVanImageModal(true, {
									heading: `${item?.id ?? '-'} at ${item?.scheduledAt
										}`,
									image: item?.receivingTempImage,
									vanTemp: item?.receivingTemp,
									id: item?.id,
									// image: 'https://placehold.co/600x400',
									// height: 400,
								});
							}}
							width={100}
							height={50}
							// src='https://placehold.co/600x400'
							src={item?.receivingTempImage}
							alt={src}
						/>
					) : (
						<>-</>
					)}
				</div>
			);
		},
		Download: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			// const clientPOId = item?.clientPoId ?? '-';
			// const deliveryDate = item?.scheduledAt;
			// const orderDate = moment(item?.createdAt).format('YYYY-MM-DD');
			// const orderStatus = item?.orderStatus;
			// const raisedBy = item?.storeName;
			// const fullFilledBy = item?.vendorName ?? '-';
			// const CommonValues = [
			// item?.id,
			// clientPOId,
			// deliveryDate,
			// orderDate,
			// orderStatus,
			// raisedBy,
			// fullFilledBy,
			// ];
			// const extraHeaders = ['Product Name', 'unit', 'Ordered Quantity'];
			return (
				<div className={styles?.downloadDiv}>
					{item?.poURL && (
						<Chip
							size='small'
							label='Order'
							onClick={() => {
								if (item?.poURL) {
									window.open(item?.poURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
					{item?.grnURL && (
						<Chip
							size='small'
							label='GRN'
							onClick={() => {
								if (item?.grnURL) {
									window.open(item?.grnURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
				</div>
			);
		},
		Vendor: (vendorName) => {
			return (
				<div
					style={{
						width: '100px',
						textAlign: 'left',
					}}
				>
					{vendorName ?? '-'}
				</div>
			);
		},
		'Order Date': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div
					style={{
						width: '100px',
						textAlign: 'left',
					}}
				>
					{moment(item?.createdAt)?.format('YYYY-MM-DD') ?? '-'}
				</div>
			);
		},
		// Actions: (itemId) => {
		// 	const item = data?.find((poItem) => {
		// 		return poItem?.id === itemId;
		// 	});
		// 	const vendorDetails = vendors?.find((ele) => {
		// 		return ele?.id === item?.vendorId;
		// 	});
		// 	return (
		// 		<div className={styles.btns}>
		// 			{item?.orderStatus === 'APPROVAL_PENDING' &&
		// 				item?.orderStatus !== 'APPROVAL_REJECTED' && userPermissions.MANAGER ? (
		// 					<Button
		// 							onClick={() => {
		// 							toggleModal(true, {
		// 								heading: `Items of Asset Purchase Orders #${
		// 								item?.clientPoId ?? item?.id
		// 							}`,
		// 								...item,
		// 								isApprove: true,
		// 								approvalText:
		// 									'I have checked all the items of Capex Order',
		// 								showTotal: true,
		// 								showPdf: true,
		// 								showPoDetails: true,
		// 								transactionData: {
		// 									'Order ID': item?.clientPoId,
		// 									'Deliver To Store': item?.storeName,
		// 									Vendor: item?.vendorName,
		// 									'Deliver To Store GSTIN': item?.storeGstin,
		// 									'Vendor GSTIN': vendorDetails?.gstin ?? '',
		// 									'Payment Term': item?.jsonData?.paymentTerm,
		// 									'Vendor Address': `${
		// 									vendorDetails?.shippingAddressCity ??
		// 									''
		// 								} ${
		// 									vendorDetails?.shippingAddressState ??
		// 									''
		// 								}, ${
		// 									vendorDetails?.shippingAddressPinCode ??
		// 									''
		// 								}`,
		// 									'Order Date': moment(item?.createdAt).format('YYYY-MM-DD'),
		// 									'Dispatch By': moment(item?.scheduledAt).format('YYYY-MM-DD'),
		// 								},
		// 								width: '90%',
		// 								height: '90%',
		// 								excludedColumns: [
		// 									'Packaged',
		// 									'Dispatched',
		// 									'Received',
		// 									'Fulfilled',
		// 									'From Process',
		// 									'PO Id',
		// 									'Returned',
		// 								],
		// 							});
		// 						}}
		// 							variant='contained'
		// 							color='primary'
		// 							fullWidth
		// 						>
		// 						Review
		// 						</Button>
		// 				) : null}
		// 			{/* {(item?.orderStatus === 'PENDING') && (
		// 				<Button
		// 					onClick={() => {
		// 						toggleAlert(true, {
		// 							heading: 'FulFill Capex Order?',
		// 							height: '15rem',
		// 							handleConfirm: () => {
		// 								handleFulfillPo(itemId);
		// 								toggleAlert(false);
		// 							},
		// 							colorReverse: false,
		// 							cancelText: 'No',
		// 							confirmText: 'Yes',
		// 							message: `Have you received the items/services of Capex order #${
		// 								item?.clientPoId || ''
		// 							}?`,
		// 						});
		// 					}}
		// 					variant='contained'
		// 					color='primary'
		// 					fullWidth
		// 				>
		// 					Fulfill PO
		// 				</Button>
		// 			)} */}
		// 			{item?.orderStatus === 'PENDING' ||
		// 				item?.orderStatus === 'APPROVAL_PENDING' ? (
		// 					<div
		// 						style={{
		// 							width: '125px',
		// 						}}
		// 					>
		// 						<Button
		// 							variant='outlined'
		// 							color='error'
		// 							onClick={() => {
		// 								toggleAlert(true, {
		// 									heading: 'Cancel PO?',
		// 									height: '15rem',
		// 									handleConfirm: () => {
		// 										handleCancelPo(
		// 											itemId,
		// 											item?.clientPoId
		// 										);
		// 										toggleAlert(false);
		// 									},
		// 									colorReverse: false,
		// 									cancelText: 'No',
		// 									confirmText: 'Yes',
		// 									message: `Are you sure you want to Cancel ${
		// 										item?.clientPoId || ''
		// 									}?`,
		// 								});
		// 							}}
		// 							fullWidth
		// 						>
		// 							Cancel PO
		// 						</Button>
		// 					</div>
		// 				) : (
		// 					'-'
		// 				)}
		// 		</div>
		// 	);
		// },

		Actions: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const vendorDetails = vendors?.find((ele) => {
				return ele?.id === item?.vendorId;
			});

			return (
				<div className={styles.btns}>
					{/* New Service Completion Button */}
					{((orderType === 'service') && (item?.orderStatus === 'APPROVAL_PENDING' &&
						item?.orderStatus !== 'APPROVAL_REJECTED') && levels.includes(level)) ? (
						<Button
							onClick={() => {
								toggleCustomModal(true, {
									header: 'Confirm Completion of Service',
									bodyContent: (
										<div className='space-y-4 p-4'>
											<p className='text-gray-700'>
												You're about to mark this order as complete. Once confirmed, the
												<span className='font-bold'>Invoice will be generated</span> based on the current Purchase Order (PO) details.
											</p>
											<p className='text-gray-700'>
												If there were any changes during the service, please make sure
												the PO is updated before proceeding.
											</p>
										</div>
									),
									actionButtons: (
										<div className='flex justify-end space-x-4 p-4'>
											<Button
												onClick={() => {
													toggleCustomModal(false)
													const redirectUrl = `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=service&typeId=9&toStore=${navSelectedStore?.value?.id}&poId=${itemId}`
													history.push(redirectUrl, {
														prevPath: location?.pathname + location?.search,
													});
												}}
												variant='outlined'
												className='border-gray-300 text-gray-700 hover:bg-gray-50'
											>
												Add Services to Order
											</Button>
											<Button
												// onClick={() => {
												//   // Add your mark complete logic here
												//   toggleCustomModal(false);

												// }}
												onClick={() => {
													handleFulfillPo(itemId, 'service')
												}}
												variant='contained'
												className='bg-yellow-400 hover:bg-yellow-500 text-black'
											>
												Mark Complete
											</Button>
										</div>
									),
									onclose: () => toggleCustomModal(false)
								});
							}}
							variant='outlined'
							className='flex items-center gap-2 border-blue-500 text-blue-600 hover:bg-blue-50'
							startIcon={<CheckCircleIcon className='w-5 h-5' />}
						>

							{/* Complete Service */}
						</Button>
					) : item?.orderStatus === 'APPROVAL_PENDING' &&
						item?.orderStatus !== 'APPROVAL_REJECTED' &&
						levels.includes(level) ? (
						<Button
							onClick={() => {
								toggleModal(true, {
									heading: `Items of Asset Purchase Orders #${item?.clientPoId ?? item?.id
										}`,
									...item,
									isApprove: true,
									approvalText:
										'I have checked all the items of Capex Order',
									showTotal: true,
									showPdf: true,
									showPoDetails: true,
									transactionData: {
										'Order ID': item?.clientPoId,
										'Deliver To Store': item?.storeName,
										Vendor: item?.vendorName,
										'Deliver To Store GSTIN':
											item?.storeGstin,
										'Vendor GSTIN':
											vendorDetails?.gstin ?? '',
										'Payment Term':
											item?.jsonData?.paymentTerm,
										'Vendor Address': `${vendorDetails?.shippingAddressCity ??
											''
											} ${vendorDetails?.shippingAddressState ??
											''
											}, ${vendorDetails?.shippingAddressPinCode ??
											''
											}`,
										'Order Date': moment(
											item?.createdAt
										).format('YYYY-MM-DD'),
										'Dispatch By': moment(
											item?.scheduledAt
										).format('YYYY-MM-DD'),
									},
									width: '90%',
									height: '90%',
									excludedColumns: [
										'Packaged',
										'Dispatched',
										'Received',
										'Fulfilled',
										'From Process',
										'PO Id',
										'Returned',
										'Last Purchase Rate 1',
										'Last Purchase Rate 2',
										'Last Purchase Rate 3',
										'Recommended Quantity',
									],
								});
							}}
							variant='contained'
							color='primary'
							fullWidth
						>
							Review
						</Button>
					) : null}

					{/* Existing Cancel PO button */}
					{item?.orderStatus === 'PENDING' ||
						item?.orderStatus === 'APPROVAL_PENDING' ? (
						<div style={{ width: '125px' }}>
							<Button
								variant='outlined'
								color='error'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Cancel PO?',
										height: '15rem',
										handleConfirm: () => {
											handleCancelPo(
												itemId,
												item?.clientPoId
											);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Cancel ${item?.clientPoId || ''
											}?`,
									});
								}}
								fullWidth
							>
								Cancel PO
							</Button>
						</div>
					) : (
						'-'
					)}
				</div>
			);
		},
	};

	const handleEditSubmit = async (editedValues) => {
		try {
			const response = await assetServices.editAssetTemp({
				data: editedValues,
				params: {
					type: 'PO',
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? error?.message,
			});
		}
	};

	const handleExport = async (filters) => {
		try {
			const response = await orderAnalyticsServices.exportGRNWiseOrderHistory({
				data: { filters: { ...filters } },
			});

			if (response.status === 200) {
				const exportType = capexOrderExportTypes?.find((ele) => {
					return ele?.value === filters?.exportType;
				});
				const exportTypeValue = exportType?.label
					?.split(' ')
					?.join('_')
					?.toUpperCase();
				const orderTypeLabel = (filters?.orderType || orderType)?.toUpperCase();
				const exportFileName = `${orderTypeLabel}_${exportTypeValue}_${filters?.dateRangeFilter?.from}_${filters?.dateRangeFilter?.to}.csv`;
				handleResponseStreamDownload(response, exportFileName);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || error,
			});
		}
	};

	const fetchVendorsOrders = (filters, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setFilterValue(filters);

		const vendorOrderFilters = {
			dateRangeFilter: {
				dateType: filters?.timeType?.value,
				from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
				to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
			},
			fromStoreId: filters?.store?.id,
			status: filters?.status ?? [],
			storeId: filters?.deliverFrom?.id === -999 ? null : filters?.deliverFrom?.id,
			vendors: filters?.vendors?.id ?? [],
			orderType: filters?.orderType || orderType,
			...(isRefresh ? null : search?.value === 'poId' ?
				{ poId: Number(search?.searchValue) } :
				{ clientPoId: search?.searchValue }
			),
		};

		exportFilters.current = vendorOrderFilters;

		const req = {
			data: {
				filters: vendorOrderFilters,
			},
		};

		fetchOrdersList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'VENDOR_ORDERS_LIST',
			req,
		});
	};

	const moreOptionsList = {};
	// 'Generate Performa Invoice': (po, cb) => {
	// if (po?.orderStatus === 'APPROVAL_PENDING') {
	// notificationServices.generateNotification({
	// type: 'error',
	// message: 'PO is not approved',
	// });
	// return null;
	// }
	// const url = `${urls.EXTENSION}${urls.BILLS}/add?poId=${po?.id}&isAdvance=true`;
	// history.push(url);
	// cb();
	// return null;
	// },
	// };

	const handleApprovePo = async (item) => {
		// setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'APPROVE',
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				toggleModal(false, {});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		// finally {
		// setIsloading(false);
		// }
	};

	const handleRejectPo = async (item, rejectionReason) => {
		// setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'REJECT',
						rejectionReason,
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				toggleModal(false, {});
				toggleAlert(false);

				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};
	const dropDownItems = [
		{
			label: 'Client PO ID',
			value: 'clientPoId',
			placeholder: 'Search by Client PO ID',
			getData: true,
		},
		{
			label: 'PO ID',
			value: 'poId',
			placeholder: 'Search by Po ID',
			getData: true,
		},
	];
	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			fetchVendorsOrders(filterValue);
		}
	}, [search?.searchValue]);


	const handleCall = (e) => {
		if (e.key === 'Enter') {
			fetchVendorsOrders();
		}
	}

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
		},
		deliverFrom: {
			text: 'Deliver To',
			show: true,
		},
		vendor: {
			text: 'Placed To (Vendor)',
			show: true,
		},
		status: {
			text: 'Order Status',
			show: true,
		},
		dateRange: {
			text: 'Order Date',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
	};

	const exportInfo = {
		showDropDown: true,
		showExportBtn: true,
		exportTypes: capexOrderExportTypes,
	};

	const handleTabChange = (value) => {
		setOrderType(value);
		const updatedFilters = {
			...filterValue,
			orderType: value
		};
		fetchVendorsOrders(updatedFilters, false, value);
	};
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const orderTypeParam = JSON.parse(queryParams.get('orderType'));
		if (orderTypeParam && !firstRender.current) {
			setOrderType(orderTypeParam);
			firstRender.current = true;
		}
	}, [location?.search]);

	return (
		<div className={styles.root}>
			<AlertModal />
			{/* <POItemsModal
				handleConfirm={handleApprovePo}
				handleReject={handleRejectPo}
			/> */}
			<ItemsModal
				handleConfirm={handleApprovePo}
				handleReject={handleRejectPo}
			/>
			<CustomModal />
			<VendorOrderGrnsModal />
			<VanImageModal handleEditSubmit={handleEditSubmit} />
			<div className={styles.header}>
				<ImagesFinder
					onSubmit={fetchVendorsOrders}
					timeTypeArray={dateTypeArr}
					statusList={filterOrderStatus?.map((ele) => {
						if (ele.id === 'FULFILLED') {
							return {
								id: ele.id,
								title: 'CLOSED',
							};
						}
						return {
							id: ele,
							title: ele,
						};
					})}
					preventDateRangeCheckbox
					filterLabels={{
						store: 'Deliver From',
					}}
					tabType={orderType}
					filtersInfo={filtersInfo}
					update={update}
					// externalFilters={externalFilters}
					orderText
					exportInfo={exportInfo}
				/>
			</div>
			<SwitchTab
				onTabChange={handleTabChange}
				activeTabName={orderType}
			/>
			<div className='flex justify-between items-center w-full p-4'>
				<span className='font-bold text-[16px]'>{orderType === 'capex' ? 'Asset Purchase Orders' : 'Service Purchase Orders'}</span>
				{/* L3 can only approve — order creation stays with other levels */}
				{level !== 1 && level !== 3 && (
					<div className='flex gap-3'>
						{/* Check for draft existence */}
						{(function () {
							let typeId = orderType === 'capex' ? 4 : 9
							const storageKey = getStorageKey(typeId);
							const draft = loadState(storageKey);

							if (draft) {
								return (
									<Button
										onClick={() => {
											const storeSelectionText = 'toStore';
											const baseUrl =
												navSelectedStore?.value
													?.id !== -999
													? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=${typeId}&${storeSelectionText}=${navSelectedStore?.value?.id}`
													: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER
													}${`?typeId=${typeId}`
													}&userOrderType=purchase`;

											history.push(
												`${baseUrl}${baseUrl.includes('?')
													? '&'
													: '?'
												}editDraft=true`,
												{
													prevPath:
														location?.pathname +
														location?.search,
												}
											);
										}}
										className='bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md flex items-center justify-center gap-2 text-white shadow-lg transform transition-all duration-1000 hover:scale-105'
									>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											className='h-5 w-5'
											viewBox='0 0 20 20'
											fill='currentColor'
										>
											<path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
										</svg>
										Edit Draft
									</Button>
								);
							}
							return null;
						})()}
						{orderType === 'service' && <Button
							onClick={() => {
								const redirectUrl =
									navSelectedStore?.value?.id !== -999
										? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=service&typeId=9&toStore=${navSelectedStore?.value?.id}`
										: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=service&typeId=9`;
								history.push(redirectUrl, {
									prevPath: location?.pathname + location?.search,
								});
							}}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ New Service Order
						</Button>}
						{orderType === 'capex' && <Button
							onClick={() => {
								const redirectUrl =
									navSelectedStore?.value?.id !== -999
										? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=4&toStore=${navSelectedStore?.value?.id}`
										: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=4`;
								history.push(redirectUrl, {
									prevPath: location?.pathname + location?.search,
								});
							}}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ New Purchase Order
						</Button>}
					</div>
				)}
			</div>
			<div className='flex gap-3 w-full justify-start items-center py-1'>
				<div className='w-[82%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip title='Refresh Asset Purchase Orders'>
					<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
						fetchVendorsOrders(filterValue, true);
					}} />
				</Tooltip>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							handleDataExport: (filtersState) =>
								handleExport({
									...exportFilters.current,
									dateRangeFilter: {
										dateType: filtersState?.timeType?.value,
										from: moment(filtersState?.dateRange?.from).format('YYYY-MM-DD'),
										to: moment(filtersState?.dateRange?.to).format('YYYY-MM-DD'),
									},
									exportType: filtersState?.exportType,
								}),
						});
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filterValue)}
			<div
				className={styles?.table}
				style={{
					width: '100%',
				}}
			>
				<ListTable
					hasDateRange
					allowChangeColumn
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={data?.map((ele) => {
						return {
							...ele,
							rowStyles: classes(
								styles.row,
								styles?.[ele?.orderStatus]
							),
						};
					})}
					actions={[...SPECIAL_COLUMNS, ...ACTION_COLUMNS]}
					special={SPECIAL_ITEMS}
					handleViewClick={handleViewClick}
					allowExport={false}
					moreOptionsList={moreOptionsList}
					viewMoreOptionsList={viewMoreOptionsList}
					typeId={9}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state?.navigation;
	const stores = state?.form?.STORES?.data?.LIST;
	const { VENDOR_ORDERS_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { LIST: vendors } = state.form.ALL_VENDORS.data;
	const { userList } = state?.auth;
	return {
		data,
		stores,
		dateRangeFilter,
		navState,
		userPermissions,
		vendors,
		userList,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.toggleItemsModal,
	toggleVendorOrderGrnsModal: modalActions.toggleVendorOrderGrnsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	// toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleTransactionsModal: modalActions.toggleTransactionsModal,
	fetchOrdersList: analyticsAction.gateway,
	fetchVendors: formActions.gateway,
	resetInventoryAnalyticsState: analyticsAction.resetInventoryAnalyticsState,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	toggleCustomModal: modalActions.toggleCustomModal
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CapexOrdersListPage);
